export const templateTypeLabels = {
  booking_confirmed: 'Booking Confirmation',
  booking_rescheduled: 'Reschedule Appointment',
  booking_cancelled: 'Cancel Appointment',
};
